export const reducer_insertData = (data) => ({
  type: "INSERT_DATA",
  data,
});
